import { render, staticRenderFns } from "./FormItemRender.vue?vue&type=template&id=27cb3086&scoped=true"
import script from "./FormItemRender.vue?vue&type=script&lang=js"
export * from "./FormItemRender.vue?vue&type=script&lang=js"
import style0 from "./FormItemRender.vue?vue&type=style&index=0&id=27cb3086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cb3086",
  null
  
)

export default component.exports